import React from 'react'
import { Col, Form, Row } from 'antd'
import { FormikProps, FormikValues } from 'formik'
import { object, setLocale, string } from 'yup'

import SelectOrganizationCurrentManager from 'src/components/Formik/select-organization-current-manager'

export function getInitialValues() {
  return {
    organization_id: ''
  }
}

export function getRenderForm() {
  return (formikProps: FormikProps<FormikValues>) => (
    <Form onSubmit={formikProps.handleSubmit}>
      <Row>
        <Col span={24}>
          <SelectOrganizationCurrentManager
            formikProps={formikProps}
            required
          />
        </Col>
      </Row>
    </Form>
  )
}

export function getValidationSchema() {
  setLocale({
    mixed: {
      notType: 'common.required',
      required: 'common.required'
    }
  })

  return object().shape({
    organization_id: string().required()
  })
}
